import * as yup from 'yup';

let uploadConsignmentExcelFileValidationForm = yup.object().shape({
  file: yup.mixed().test('required', 'Excel File is required', (file) => {
    // @ts-ignore
    if (file?.length) return true;
    return false;
  }),
});

let ConsignmentRemarksValidationForm = yup.object().shape({
  comment: yup.string().required('Remarks is required'),
});

let createCustomerValidationForm = yup.object().shape({
  full_name: yup.string().required('Email is required'),
  primary_contact: yup.string().required('Phone number is required'),
  address: yup.string().required('Address is required'),
});
export {
  uploadConsignmentExcelFileValidationForm,
  ConsignmentRemarksValidationForm,
  createCustomerValidationForm,
};
